import { ICommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { PlannedCourse } from '../../../global/builders/planned_course_builder';
import { APPlannedCourseServant } from '../../../global/servants/ap_planned_course_servant';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from '../../../plan/constants/event_names';
import { APDegreeMapQuery } from '../../components/degree_map/queries/ap_degree_map_query';
import { APGoalSetsQuery } from '../../queries/ap_goal_sets_query';
import { APStudentDetailsQuery } from './../../../global/components/student_details/queries/student_details_query';
import { APAdvisorText } from './../../../global/servants/ap_advisor_text_servant';
import { APMultiDegreeTemplateQuery } from './queries/ap_multi_degree_template_query';

export class APMultiDegreeTemplateController {
  private advisorText: string = 'advisor';
  private isEditable: boolean | string;
  private isDegreeMapLoading: boolean;
  private showDegreeMapLoadingIndicatorBound: () => void;
  private hideDegreeMapLoadingIndicatorBound: () => void;

  constructor(
    private ngAPAdvisorText: APAdvisorText,
    private ngAPMultiDegreeTemplateQuery: APMultiDegreeTemplateQuery,
    private ngComponentCommunicatorService: CommunicatorService,
    private phxFeatureConfiguration: any,
    private ngAPGoalSetsQuery: APGoalSetsQuery,
    private accountModel: AccountModel,
    private ngAPStudentDetailsQuery: APStudentDetailsQuery,
    private loadMmDegreeMapCommand: ICommand
  ) {
    this.showDegreeMapLoadingIndicatorBound = this.showDegreeMapLoadingIndicator.bind(this);
    this.hideDegreeMapLoadingIndicatorBound = this.hideDegreeMapLoadingIndicator.bind(this);
  }
  $onInit() {
    this.ngComponentCommunicatorService.subscribe('DEGREE_MAP_LOADING', this.showDegreeMapLoadingIndicatorBound);
    this.ngComponentCommunicatorService.subscribe(
      'DEGREE_MAP_LOADING_SUCCESS',
      this.hideDegreeMapLoadingIndicatorBound
    );
    this.ngComponentCommunicatorService.subscribe(
      'DEGREE_MAP_LOADING_FAILURE',
      this.hideDegreeMapLoadingIndicatorBound
    );
  }

  $onChanges() {
    this.advisorText = this.ngAPAdvisorText.advisorLabel;
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
  }

  onGoalSetSelectionChangedEvent(event: any) {
    const goalSetId = _4.get(event, 'detail.value', 0);
    const studentId =
      _4.get(this.accountModel, 'student_nk', 0) || _4.get(this.ngAPStudentDetailsQuery, 'result.id', 0);
    this.loadMmDegreeMapCommand(studentId, goalSetId);
  }

  showDegreeMapLoadingIndicator() {
    this.isDegreeMapLoading = true;
  }
  hideDegreeMapLoadingIndicator() {
    this.isDegreeMapLoading = false;
  }
}

class APMultiDegreeTemplateComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      isEditable: '<?'
    };
    this.controller = APMultiDegreeTemplateController;
    this.templateUrl = 'capability-ng-academic-planner/src/plan/components/degree_map/multi_degree_map.html';
  }
}
angular
  .module('capability-ng-academic-planner')
  .component('apMultiDegreeTemplate', new APMultiDegreeTemplateComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/degree_map/multi_degree_map.ts